import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const UsuariosController = {
    async ListUsers() {
        try {
          const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`user_page/`, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data.result;
        } catch (error) {
          console.error("Error fetching transcripts:", error);
          throw error;
        }
      },
      async AddUser(newUsuarioLogin,newUsuarioSenha, newUsuarioEmail) {
        try {
          const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `user_page/`, {
            login: newUsuarioLogin,
            password: newUsuarioSenha,
            email: newUsuarioEmail
          }, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data;
        } catch (error) {
          console.error("Error creating user:", error);
          throw error;
        }
      },
      async DeleteUser(Id) {
        try {
          const response = await axios.delete(
            `${AppConfig.BACKEND_URL_REFATORADO}user_page/edit_user/${Id}`,
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error deleting user:", error);
          throw error;
        }
      },
      async PutUser(Id, login, email, menu) {
        try {
          const response = await axios.put(
            `${AppConfig.BACKEND_URL_REFATORADO}user_page/edit_user/${Id}`,
            { login, email, menu },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error updating user:", error);
          throw error;
        }
      },
};

export default UsuariosController;